import {Component, ComponentFactoryResolver, HostListener, OnInit, ViewContainerRef} from '@angular/core';
import {GlobalServices} from '../global.services';
import {ApiService} from '../api.service';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { of } from 'rxjs/internal/observable/of';
import { error } from 'protractor';
import {baseUrls} from '../appConstant';

@Component({
  templateUrl: './forgotpass.component.html',
  styleUrls: ['./forgotpass.component.scss']
})
export class ForgotpassComponent implements OnInit {
  public clickcheck = 0;
  public auth2: any;
  public mode: any;
  public submitted: boolean = false;
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.globalServices.isBrowser) {
      if (!document.getElementById('signin-wrap')?.contains(event.target) && this.clickcheck !== 0) {
        this.globalServices.viewcontainerhelper.clear();
        this.clickcheck = 0;
      } else {
        this.clickcheck = 1;
      }
    }
  }
  public forgetPassword:FormGroup;
  constructor(public globalServices: GlobalServices, private httpService: ApiService, public cfr: ComponentFactoryResolver, private viewContainerRef: ViewContainerRef,public fb:FormBuilder) {
    this.forgetPassword = this.fb.group({

      email: ['', Validators.required, this.emailDomainValidator.bind(this)],
    });
   }

  emailDomainValidator(control: FormControl) {

    let email = control.value;
    if (email && email.indexOf("@") != -1) {
      let [_, domain] = email.split("@");
      if (domain.length < 5) {
        return of({
          emailDomain: {
            parsedDomain: domain
          }
        })
      } else {
        if (domain && domain.indexOf(".") != -1) {
          let [before, after] = domain.split(".");
          if (before.length < 2) {
            return of({
              emailDomain: {
                parsedDomain: domain
              }
            })
          } else if (after.length < 2) {
            return of({
              emailDomain: {
                parsedDomain: domain
              }
            })
          } else {
            return of(null);
          }

        } else {
          return of({
            emailDomain: {
              parsedDomain: domain
            }
          })
        }
      }
    } else {
      return of({
        emailDomain: {
          parsedDomain: control.value
        }
      });
    }

  }

  // convenience getter for easy access to form fields
  get f() { return this.forgetPassword.controls; }
  ngOnInit(): void {
  }
  public errorMessage:string = '';
  public showAlert: boolean = false;
  public responseMessage: string = "";
  public submitpassword():void{
    this.submitted =true;
    if(this.forgetPassword.invalid){
      return;
    }
    let obj = {
      email:this.forgetPassword['controls']['email']['value'],
      url: baseUrls['global'] + 'resetpassword/'
    }
    let url = 'user/forgot-password-link';
    this.mode = 'indeterminate';
    this.httpService.postFormData(url,obj).subscribe((response:any)=>{
          if(response){
              this.mode = 'determinate';
            if(response['success']){
          this.responseMessage=response['success']?response['message']:'';
          this.showAlert = true;
          setTimeout(()=>{
            this.closecomponent();         
          },3000);
          }else{
            this.errorMessage=response['message'];
            setTimeout(()=>{
              this.errorMessage='';        
            },2000);     
          }
        }
    },(error)=>{
      this.mode = 'determinate';
      if(error)
     this.errorMessage=error['message'];
     setTimeout(()=>{
      this.errorMessage='';         
    },4000);
    });
  }
  public triggerCloseEvent() {
    this.showAlert = false;
  }
  closecomponent(){
    // console.log('123');
    this.globalServices.viewcontainerhelper.clear();
    this.globalServices.headerviewcontainerhelper.clear();
  }

}
